"use strict";

import { getNamedContext } from "../getNamedContext.js";
export const HeaderShownContext = getNamedContext('HeaderShownContext', false);
//# sourceMappingURL=HeaderShownContext.js.map